import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { LoadingService } from 'src/app/core/services/loader.service';
import { UsersService } from '../services/users.service';

@Component({
  selector: 'app-login-otp',
  templateUrl: './login-otp.component.html',
  styleUrls: ['./login-otp.component.scss'],
})
export class LoginOtpComponent implements OnInit, OnDestroy {
  hide = true;
  SendOTPButton = 'Send OTP';
  Verifybutton = 'Verify';
  otpTried = 0;
  timer = 60;
  inerval;
  resendButton = false;
  applicationForm: FormGroup;
  constructor(
    public dialogRef: MatDialogRef<LoginOtpComponent>,
    private formBuilder: FormBuilder,
    private userService: UsersService,
    private auth: AuthenticationService,
    private loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    this.applicationForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }
  ngOnDestroy(): void {
    this.clearTimeInterval();
  }
  changeEmail() {
    this.otpTried = 0;
    this.applicationForm.get('username').enable();
    this.clearTimeInterval();
  }
  sendOtp() {
    if (this.otpTried < 5) {
      if (this.applicationForm.get('username').invalid) {
        this.auth.showSnackBarMsg('Username is required!.');
        return;
      }
      this.SendOTPButton = 'Please wait..';
      this.loadingService.startLoading();
      this.userService.sendOtp(this.applicationForm.getRawValue()).subscribe(
        (response) => {
          if (response) {
            this.otpTried++;
            this.applicationForm.get('username').disable();
            this.loadingService.stopLoading();
            this.auth.showSnackBarMsg('OTP sent successfully!.');

            this.timer = 60;
            this.resendButton = true;
            this.setTimeInterval();
          }
        },
        (err) => {
          console.log('error', err);
          if (err.error.message === 'Email not Found') {
            this.auth.showSnackBarMsg('Email Not Found!.');
          } else {
            this.auth.showSnackBarMsg('Something Went Wrong, try again!.');
          }
          this.SendOTPButton = 'Send OTP';
          this.loadingService.stopLoading();
        }
      );
    }
  }
  setTimeInterval() {
    if (this.inerval) {
      clearInterval(this.inerval);
    }
    this.inerval = setInterval(() => {
      console.log(this.timer);
      if (this.timer == 0) {
        this.resendButton = false;
        clearInterval(this.inerval);
      } else {
        this.timer--;
      }
    }, 1000);
  }
  verifyOtp() {
    if (this.applicationForm.invalid) {
      return;
    }
    this.Verifybutton = 'Please wait..';
    this.loadingService.startLoading();
    console.log(this.applicationForm.getRawValue());
    this.userService.loginWithOtp(this.applicationForm.getRawValue()).subscribe(
      (response) => {
        if (response) {
          this.clearTimeInterval();
          this.setToken(response.data.accessToken);
          this.setImage(response.data.image);
          this.auth.autoLogout();
          this.loadingService.stopLoading();
          this.auth.fetchingData.next(this.auth.getCurrentUrl());
          this.dialogRef.close('loggedIn');
        }
      },
      (err) => {
        if (err.error.message === 'otpNotMatch') {
          this.auth.showSnackBarMsg('OTP is incorrect!');
        } else if (err.error.message === 'expireOTP') {
          this.auth.showSnackBarMsg('OTP Expired!');
        } else {
          this.auth.showSnackBarMsg('OTP is incorrect.');
        }
        this.loadingService.stopLoading();
        this.Verifybutton = 'Verify';
      }
    );
  }
  clearTimeInterval() {
    if (this.inerval) {
      clearInterval(this.inerval);
    }
  }
  backToLogin() {
    this.dialogRef.close('backToLogin');
  }
  onRegister() {
    this.dialogRef.close('onRegister');
  }
  // forgotPassword() {
  //   this.dialogRef.close('forgotPassword');
  // }

  /**
   * Sets token
   *
   * @param response User data
   */
  setToken(response) {
    this.auth.setLoginUserDetail(response);
    this.auth.isLoggedIn = true;
  }

  /**
   * Sets image
   *
   * @param response User data
   */
  setImage(response) {
    this.auth.setLoginUserImage(response);
  }
}
